/* EMEA-only component — do not import outside isEMEAStore() guarded paths */
import { removeSpaces } from 'utils/iteroContractUtils';
import { CustomerInfoTableProps } from 'components/ITeroTermsConditionsModalEMEA/ITeroTermsConditionsModalEMEA.type';
import { Styled } from './';
import { useI18n } from 'contexts/i18n';

const ContactInfoTable = ({
  additionalOrderInfo,
  doctorProfile,
  selectedBillingAddress,
  selectedShippingAddress,
}: CustomerInfoTableProps) => {
  const i18n = useI18n();
  const customerName = additionalOrderInfo?.doctorName || '\\fn1\\';
  const customerEmail =
    removeSpaces(additionalOrderInfo?.contactEmail) || '\\cema1\\';
  const customerPhone = additionalOrderInfo?.doctorPhone || '';
  const contactName =
    `${additionalOrderInfo?.firstName || ''} ${
      additionalOrderInfo?.lastName || ''
    }`.trim() || '';
  const contactEmail = removeSpaces(additionalOrderInfo?.directEmail) || '';
  const contactPhone = additionalOrderInfo?.directPhone || '';
  const customerClinID = doctorProfile?.userName || '';
  const scannerRegistrationEmail =
    removeSpaces(additionalOrderInfo?.scannerLoginEmail) || '';

  return (
    <Styled.Table>
      <Styled.TableHeader>
        <Styled.TableHeaderRow>
          <Styled.TableHeaderCell>
            {i18n['Customer Information']}
          </Styled.TableHeaderCell>
          <Styled.TableHeaderCell>
            {i18n['Contact Information']}
          </Styled.TableHeaderCell>
        </Styled.TableHeaderRow>
      </Styled.TableHeader>
      <Styled.TableBody>
        <Styled.TableRow>
          <Styled.TableCell>
            <Styled.FieldValue>
              <Styled.FieldLabel>{i18n['Customer Name:']}</Styled.FieldLabel>{' '}
              {customerName}
            </Styled.FieldValue>
          </Styled.TableCell>
          <Styled.TableCell>
            <Styled.FieldValue>
              <Styled.FieldLabel>{i18n['Contact Name:']}</Styled.FieldLabel>{' '}
              {contactName}
            </Styled.FieldValue>
          </Styled.TableCell>
        </Styled.TableRow>
        <Styled.TableRow>
          <Styled.TableCell>
            <Styled.FieldValue>
              <Styled.FieldLabel>{i18n['Customer Email:']}</Styled.FieldLabel>{' '}
              {customerEmail}
            </Styled.FieldValue>
          </Styled.TableCell>
          <Styled.TableCell>
            <Styled.FieldValue>
              <Styled.FieldLabel>{i18n['Contact Email:']}</Styled.FieldLabel>{' '}
              {contactEmail}
            </Styled.FieldValue>
          </Styled.TableCell>
        </Styled.TableRow>
        <Styled.TableRow>
          <Styled.TableCell>
            <Styled.FieldValue>
              <Styled.FieldLabel>
                {i18n['Customer Phone Number:']}
              </Styled.FieldLabel>{' '}
              {customerPhone}
            </Styled.FieldValue>
          </Styled.TableCell>
          <Styled.TableCell>
            <Styled.FieldValue>
              <Styled.FieldLabel>
                {i18n['Contact Phone Number:']}
              </Styled.FieldLabel>{' '}
              {contactPhone}
            </Styled.FieldValue>
          </Styled.TableCell>
        </Styled.TableRow>
        <Styled.TableRow>
          <Styled.TableCell>
            <Styled.FieldValue>
              <Styled.FieldLabel>
                {i18n['Customer Bill to Address:']}
              </Styled.FieldLabel>
            </Styled.FieldValue>
            <Styled.FieldValue>
              {selectedBillingAddress?.mailingName}
            </Styled.FieldValue>
            <Styled.FieldValue>
              {selectedBillingAddress?.address1}
            </Styled.FieldValue>
            <Styled.FieldValue>
              {selectedBillingAddress?.address2}
            </Styled.FieldValue>
            <Styled.FieldValue>
              {selectedBillingAddress?.address3}
            </Styled.FieldValue>
            <Styled.FieldValue>
              {selectedBillingAddress?.city} {selectedBillingAddress?.zipcode}
            </Styled.FieldValue>
            <Styled.FieldValue>
              {selectedBillingAddress?.countryIso}
            </Styled.FieldValue>
          </Styled.TableCell>
          <Styled.TableCell>
            <Styled.FieldValue>
              <Styled.FieldLabel>
                {i18n['Customer Shipping Address:']}
              </Styled.FieldLabel>
            </Styled.FieldValue>
            <Styled.FieldValue>
              {selectedShippingAddress?.mailingName}
            </Styled.FieldValue>
            <Styled.FieldValue>
              {selectedShippingAddress?.address1}
            </Styled.FieldValue>
            <Styled.FieldValue>
              {selectedShippingAddress?.address2}
            </Styled.FieldValue>
            <Styled.FieldValue>
              {selectedShippingAddress?.address3}
            </Styled.FieldValue>
            <Styled.FieldValue>
              {selectedShippingAddress?.city} {selectedShippingAddress?.zipcode}
            </Styled.FieldValue>
            <Styled.FieldValue>
              {selectedShippingAddress?.countryIso}
            </Styled.FieldValue>
          </Styled.TableCell>
        </Styled.TableRow>
        <Styled.TableRow>
          <Styled.TableCellBottom>
            <Styled.FieldValue>
              <Styled.FieldLabel>{i18n['Customer ClinID:']}</Styled.FieldLabel>{' '}
              {customerClinID}
            </Styled.FieldValue>
          </Styled.TableCellBottom>
          <Styled.TableCellBottom>
            <Styled.FieldValue>
              <Styled.FieldLabel>
                {i18n['Scanner Registration Email:']}
              </Styled.FieldLabel>{' '}
              {scannerRegistrationEmail}
            </Styled.FieldValue>
          </Styled.TableCellBottom>
        </Styled.TableRow>
      </Styled.TableBody>
    </Styled.Table>
  );
};

export default ContactInfoTable;
